import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { IGTM, ISystemEvent } from '../../../shared/models/events.model';
import { ApiService, CampaignService, EventsService, UtilService, VariablesService } from '../../../shared/services';
import { DialogService } from '../../../shared/components/dialog/service/dialog.service';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { IUser } from '../../../shared/models';


@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss']
})
export class DescriptionComponent implements OnInit {

  descForm: FormGroup;
  desc: FormControl;
  termsCondition: FormControl;
  insuranceCondition: FormControl;
  showInsuranceCondition: boolean;
  @ViewChild('infoDialog', { static: true }) infoDialog;
  @ViewChild('successDialog', { static: true }) successDialog;
  @Input() draft;
  type: string;
  @Input() info;
  origin;
  managerNo;
  isLoading = false;
  showPopover;
  medicalDocs = [
    { label: 'Treatment Cost Estimate Letter', value: 'Treatment Cost Estimate Letter' },
    { label: 'Itemised IP Bill / Bill of Supply', value: 'Itemised IP Bill / Bill of Supply' },
    { label: 'Case Summary Report', value: 'Case Summary Report' },
    { label: 'Diagnostic / Prescription Report', value: 'Diagnostic / Prescription Report' },
    { label: 'Discharge Summary Report', value: 'Discharge Summary Report' },
    { label: 'Hospital Admission Letter', value: 'Hospital Admission Letter' },
    { label: 'Payment Receipt/Invoice', value: 'Payment Receipt/Invoice' },
    { label: 'Lab Test Report (X-Ray, MRI, etc.)', value: 'Lab Test Report (X-Ray, MRI, etc.)' },
    { label: 'Death Summary Report', value: 'Death Summary Report' },
  ];
  isPersonalCampaign = false;

  constructor(
    public util: UtilService,
    private campaignService: CampaignService,
    private events: EventsService,
    public vars: VariablesService,
    private router: Router,
    private actRoute: ActivatedRoute,
    public dialog: DialogService,
    private api: ApiService,
    private datePipe: DatePipe
  ) {
    this.getDraft();
  }

  ngOnInit() {
    this.initForm();
    this.getCampaignType();
    if (typeof window !== 'undefined') {
      this.origin = window.location.origin;
    }
    this.showInsuranceCondition = this.util.getUserData().insurance ? true : false;
  }

  checkPersonalCampaign() {
    this.isPersonalCampaign = this.draft.parent_cause_id === 20 && this.draft.cause_id !== 192;
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.type = this.actRoute.snapshot.queryParams['type'];
    this.vars.draftObs.subscribe((res) => {
      const user: IUser = this.util.getUserData();
      const data = {
        Site: {
          'CampaignID': res?.id,
          'Identity': user?.id,
          'Email': user?.email,
          'SAF_Language': this.util.storage.get('language') || 'English',
        }
      };
      this.events.claverProfilePush(data)
      this.draft = res;
      this.checkPersonalCampaign();
      if (res.about) {
        this.patchForm(res);
      }
    });
  }
  /**Get the type of the campaign */
  getCampaignType() {
    this.util.campaignType$.subscribe((res) => {
      if (res) {
        this.type = res;
      }
    });
  }
  /**
   * Init the form
   */
  initForm() {
    this.descForm = new FormGroup({
      desc: this.desc = new FormControl('', [Validators.required, Validators.minLength(50)]),
      termsConditon: this.termsCondition = new FormControl(true, [Validators.required]),
      insuranceCondition: this.insuranceCondition = new FormControl(true)
    });
  }
  /**Open dialog/modal */
  openDialog(dialog): void {
    const dialogRef = this.dialog.openDialog(dialog, {
      // width: '96vw',
      maxWidth: '96vw',
      panelClass: 'round-dialog'
    });
    dialogRef.afterClosed().subscribe(result => result);
  }
  /**close dialog */
  closeDialog() {
    this.dialog.closeDialog();
  }
  /**Get assistance */
  getAssist() {
    this.closeDialog();
    this.sendAssistenceEnquiry();
  }
  /**External url */
  goExternal(url) {
    if (typeof document !== 'undefined') {
      document.location.href = url;
    }
  }
  /**update info */
  updateInfoDraft() {
    if (this.draft && this.draft.hasOwnProperty('about')) {
      this.draft.about = {
        'info_1': this.desc.value
      };
    }
  }
  /**Submit form */
  submit(formValues) {
    if (!formValues.termsConditon) {
      this.util.openSnackBar('Please indicate that you have read and agreed to the Terms and Conditions and Privacy Policy', 'error');
    } else if (this.desc.value.length >= 50) {
      this.isLoading = true;
      const payload = {
        'about': {
          'entity_type': 'campaign',
          'info_1': formValues.desc,
          'info_type': 'social'
        }
      };
      this.updateCampaign(payload, this.draft.id);
    } else {
      this.util.checkValidForm(this.descForm);
    }
  }
  /**Submit button click mock */
  submitButton() {
    if (typeof document !== 'undefined') {
      document.getElementById('descSubmitBtn').click();
    }
  }
  /**Patch form */
  patchForm(data) {
    this.descForm.patchValue({
      'desc': data.about.info_1,
    });
  }
  /**Update Campaign
   * @param payload required data for updating campaign
  */
  updateCampaign(payload, id) {
    this.campaignService.updateCampaign(payload, id).subscribe((res: any) => {
      this.draft.about = res.data.about;
      this.vars.draftObs.next(this.draft);
      this.gtmPush();
      this.sendSystemEvent();
      if (this.draft.parent_cause_id === 49) {
        this.util.navigateToForm('rewards', this.type, this.draft.id);
        this.isLoading = false;
      } else {
        this.publishCampaign();
      }
      this.sendDraftLead();
    });
  }
  publishCampaign() {
    const validCauseID = [150, 59, 156, 4, 160];
    let payload :any= {
      'status_flag': 8,
    };
    
    if (!this.showInsuranceCondition) {
      payload.insurance_opt_in = this.insuranceCondition.value;
    }
    
    this.campaignService.publishCampaign(payload, this.draft.id).subscribe((res: any) => {
      this.util.openSnackBar('Fundraiser Successfully created', 'success');
      this.isLoading = false;
      const askPatientNo = this.util.storage.getFromSession('askpatientNumber');
      const guardian = askPatientNo ? askPatientNo.askpatientNumber === 'Patient\'s no. required' ? 'No' : 'Yes' : '';
      const patientMobile = askPatientNo ? askPatientNo.phone_1 : '';
      const patientRelation = this.draft.beneficiaryrelation ? this.draft.beneficiaryrelation.info_1 : '';
      this.util.storage.deleteFromSession('askpatientNumber');
      this.router.navigate(['new/campaign-thank-you'], {
        queryParams: { type: 'medical', custom_tag: res.data.custom_tag, saf_source: this.actRoute.snapshot.queryParams.saf_source },
        queryParamsHandling: ''
      });

      const campaign_start_date = new Date(res.data.start_date);
      campaign_start_date.setDate(campaign_start_date.getDate() + 15);
      const campaign_expiry_date = this.datePipe.transform(campaign_start_date, 'yyyy-MM-dd');

      // if ( validCauseID.includes(this.draft.cause_id) && this.draft.parent_cause_id === 20) {
      const cleverTap = {
        'CampaignerName': this.draft.owner.full_name,
        'CampaignID': this.draft.id,
        'CampaignerMobile': this.draft.owner.phone_1,
        'Guardian': guardian,
        'PatientMobile': patientMobile,
        'PatientName': this.draft.beneficiaryname.info_1,
        'PatientAge': this.draft.beneficiaryage.info_1,
        'AmountTBRaised': this.draft.amount_requested,
        'PatientRelationWithCampaigner': patientRelation,
        'PatientDisease': this.draft.disease.info_1,
        'PatientHospital': this.draft.hospital ? this.draft.hospital.info_1 : 'Not Admitted',
        'CampaignURL': `${this.util.domain_details.domain_url}/fundraiser/${res.data.custom_tag}`,
        'ParentCauseID': this.draft.parent_cause_id,
        'CauseID': this.draft.cause_id,
        'FundraiserExpiryDate': campaign_expiry_date,
        'UrlencodeCampaignName': encodeURI(res.data.title),
        'CustomTag': `${res.data.custom_tag}`
      };
      if (this.draft?.parent_cause_id === 20 && this.draft?.cause_id === 59 && this.draft?.disease?.info_2) {
        cleverTap['ParentDiseaseId'] = this.draft.disease.info_2;
        cleverTap['City'] = this.draft.address_1;
      }
      const user: IUser = this.util.getUserData();
      this.events.claverTapPush('Fundraiser Started', cleverTap);
      const data = {
        Site: {
          'CampaignID': this.draft.id,
          'SAF_Language': this.util.storage.get('language') || 'English',
          'Identity': user?.id,
          'Email': user?.email,
        }
      };
      this.events.claverProfilePush(data)
      // }

      return res;
    });
  }
  /**Send the assistence enquiry */
  sendAssistenceEnquiry() {
    this.managerNo = this.setManager();
    const userData = this.util.getUserData();
    const payload = {
      name: userData?.full_name,
      email: userData?.email,
      phone: userData?.phone_1,
      page: 'Start a Fundraiser',
      type: 'get-assistance-lead',
      campaign_id: this.draft.id,
      cause: 'medical',
      mail_to: this.vars.leadMailTo,
      subject: 'Helpmewritethis-' + this.vars.leadSubject,
      city: this.util.getCityFromIp()
    };
    Object.assign(payload, this.util.getUTMs());
    this.campaignService.sendAssistenceEnquiry(payload).subscribe(
      (res) => {
        const sysEvent = {
          eventName: 'get-assistance-lead',
          event_type: 'campaign',
          info_2: this.draft.id,
          page_name: 'Start a Fundraiser',
        };
        this.events.sendSystemEvent(sysEvent).subscribe();
        this.openDialog(this.successDialog);
      },
      (err) => {
        this.openDialog(this.successDialog);
      }
    );
  }
  /**Set campaign manager */
  setManager() {
    return this.draft.manager.entity.phone_1;
  }
  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent() {
    const payload: ISystemEvent = {
      eventName: 'start_a_campaign_step3_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step3',
      info_1: 'type',
      info_2: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      info_3: this.util.storage.get('language') || 'English'
    };
    if (this.draft?.id) {
      payload['event_type_id'] = this.draft?.id;
    }
    this.events.systemEventPush(payload);
  }
  /**GTM data push */
  gtmPush() {
    const dataPush: IGTM = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: this.util.getCampaignTypeFromId(this.draft.parent_cause_id),
      eventLabel: 'step3_completed',
      Campaign_cause_id: this.draft.cause_id,
      Campaign_id: this.draft.id,
      Campaign_Type: this.util.getCampaignTypeFromId(this.draft.parent_cause_id)
    };
    this.events.gtmPush(dataPush);
  }

  openDeleteModal(mediaId): void {
    const dialogRef = this.dialog.openDialog({ title: 'Are you sure', type: 'confirmDelete', deleteMsg: 'image' }, {
      height: 'auto',
      width: this.util.isMobile() ? '90vw' : '320px',
      panelClass: 'edit-update',
      closeOnNavigation: false
    });
    this.dialog.dialogRef.componentInstance.deleteObs.subscribe((value) => {
      if (value) {
        this.deleteMedia(mediaId);
      }
    });
  }

  deleteMedia(mediaId): void {
    this.dialog.dialogRef.componentInstance.isLoading = true;
    const url = environment.APP.API_URLS.DELETE_MEDIA(this.vars.campaignId, mediaId);
    this.api.delete(url).subscribe((res) => {
      this.dialog.dialogRef.close();
      this.dialog.dialogRef.componentInstance.isLoading = false;
      this.vars.medicalbill = this.vars.medicalbill.filter(item => item.id !== mediaId);
      this.util.openSnackBar('Image deleted successfully!', 'success');
    }, () => this.dialog.dialogRef.componentInstance.isLoading = false);
  }

  sendDraftLead() {
    const payload: any = {
      type: 'Preapproved campaign',
      subject: 'Draft campaign',
      parent_cause_id: this.draft?.parent_cause_id,
      cause_id: this.draft?.cause_id,
      cause_name: this.draft?.cause?.info_1,
      description: this.desc?.value,
      CID: this.draft?.id
    };
    this.events.sendLead(payload);
  }
}
